var dateInputs = document.querySelectorAll('input[type="date"], input[type="time"]');

dateInputs.forEach(function(input) {
    input.addEventListener('change', function() {
        if (this.value) {
            this.classList.add('has-value');
        } else {
            this.classList.remove('has-value');
        }
    });
});